import { t } from '@lingui/core/macro'

export const Routes = {
  ROOT: '/',
  HOME: '/home',
  SUPER_ADMIN: '/superAdmin',
  GRUPOS: '/grupos',
  GRUPO_NOVO: '/grupos/novo',
  GRUPO: '/grupos/:id',
  DEALER_NOVO: '/dealers/novo',
  DEALER: '/dealers/:id',
  DEALERS: '/dealers',
  USUARIOS: '/usuarios',
  USUARIO_NOVO: '/usuarios/novo',
  USUARIO: '/usuarios/:id',
  AUSENCIA_TEMPORARIA: '/usuarios/:id/ausencia-temporaria',
  GRUPOS_USUARIOS: '/gruposUsuarios',
  GRUPO_USUARIOS_NOVO: '/gruposUsuarios/novo',
  GRUPO_USUARIOS: '/gruposUsuarios/:id',
  AUDITORIA: '/auditoria/:id/:tipo',
  BIBLIOTECA_VIRTUAL_PASTA: '/biblioteca/:idPasta',
  BIBLIOTECA_VIRTUAL: '/biblioteca',
  COMUNICADOS_NOVO: '/comunicados/novo',
  COMUNICADO_EDICAO: '/comunicados/editar/:id',
  COMUNICADO_ERRATA: '/comunicados/errata/:id',
  COMUNICADO_ENVIO_VISUALIZACAO: '/comunicados/visualizarEnvio/:id',
  COMUNICADO_VISUALIZACAO: '/comunicados/visualizar/:id',
  COMUNICADO_DASHBOARD: '/comunicados/dashboard/:id',
  COMUNICADOS: '/comunicados',
  MINHA_CONTA: '/minha-conta',
  SLIDES: '/slides',
  SLIDE_NOVO: '/slides/novo',
  SLIDE_EDICAO: '/slides/editar/:id',
  ANUNCIO_NOVO: '/anuncios/novo',
  ANUNCIO_EDICAO: '/anuncios/editar/:id',
  ANUNCIOS: '/anuncios',
  NOTIFICACOES: '/notificacoes',
  NOTIFICACOES_GENERICAS: '/notificacoesGenericas',
  NOTIFICACAO_NOVA: '/notificacoesGenericas/nova/:tipo',
  NOTIFICACAO_EDICAO: '/notificacoesGenericas/editar/:tipo/:id',
  IMPORTAR_USUARIOS: '/importarUsuarios',
  RELATORIO_PAGE: '/relatorio/:slug'
}

export const RouteMeta = [
  { path: '/', label: t`Início` },
  { path: '/home', label: t`Início` },
  { path: '/superAdmin', label: t`Super Admin` },
  { path: '/grupos', label: t`Grupo de Dealers` },
  { path: '/grupos/novo', label: t`Novo Grupo de Dealers` },
  { path: '/grupos/:id', label: t`Editar Grupo de Dealers` },
  { path: '/dealers/novo', label: t`Novo Dealer` },
  { path: '/dealers/:id', label: t`Editar Dealer` },
  { path: '/dealers', label: t`Dealers` },
  { path: '/usuarios', label: t`Usuários` },
  { path: '/usuarios/novo', label: t`Novo Usuário` },
  { path: '/usuarios/:id', label: t`Editar Usuário` },
  {
    path: '/usuarios/:id/ausencia-temporaria',
    label: t`Ausências Temporárias`
  },
  { path: '/gruposUsuarios', label: t`Grupo de Usuários` },
  {
    path: '/gruposUsuarios/novo',
    label: t`Novo Grupo de Usuários`
  },
  {
    path: '/gruposUsuarios/:id',
    label: t`Editar Grupo de Usuários`
  },
  { path: '/auditoria/:id/:tipo', label: t`Auditoria` },
  {
    path: '/biblioteca/:idPasta',
    label: t`Pasta`
  },
  { path: '/biblioteca', label: t`Biblioteca Virtual` },
  { path: '/comunicados/novo', label: t`Novo Comunicado` },
  {
    path: '/comunicados/editar/:id',
    label: t`Editar Comunicado`
  },
  {
    path: '/comunicados/errata/:id',
    label: t`Criar Errata`
  },
  {
    path: '/comunicados/visualizarEnvio/:id',
    label: t`Visualizar Envio`
  },
  {
    path: '/comunicados/visualizar/:id',
    label: t`Visualizar Comunicado`
  },
  {
    path: '/comunicados/dashboard/:id',
    label: t`Dashboard de Comunicado`
  },
  { path: '/comunicados', label: t`Comunicados` },
  { path: '/minha-conta', label: t`Minha Conta` },
  { path: '/slides', label: t`Slides` },
  { path: '/slides/novo', label: t`Novo Slide` },
  { path: '/slides/editar/:id', label: t`Editar Slide` },
  { path: '/anuncios/novo', label: t`Novo Anúncio` },
  { path: '/anuncios/editar/:id', label: t`Editar Anúncio` },
  { path: '/anuncios', label: t`Anúncios` },
  { path: '/notificacoes', label: t`Notificações` },
  {
    path: '/notificacoesGenericas',
    label: t`Notificações Genéricas`
  },
  {
    path: '/notificacoesGenericas/nova/:tipo',
    label: t`Nova Notificação`
  },
  {
    path: '/notificacoesGenericas/editar/:tipo/:id',
    label: t`Editar Notificação`
  },
  { path: '/importarUsuarios', label: t`Importar Usuários` },
  { path: '/relatorio/:slug', label: t`Relatório` }
]
